// extracted by mini-css-extract-plugin
export default {"testSearch":"_2DMUn6NoiSaLLe6AxWa7Xy","text-map":"_1tBInS2BWg6suhr10fOTBb","col-lg-8":"_3kxTPbQgQKZUs0x4-tXE9l","col-lg-4":"_1tTPUqxYf4WptpDfQ_Ho4E","text":"_2Hi-GhSJJtVwCAiq_BWauV"};